import { instance } from '../../config/intercepter';

// todo check post method
export const getCarFn = async (searchTerm = '', pageParam = 1, length = 25, selectedDriver) => {
  let urlParams = selectedDriver===undefined ? `length=${length}&search=${searchTerm}&page=${pageParam}`: `length=${length}&search=${searchTerm}&page=${pageParam}&hide=${selectedDriver}`
  const response = await instance.get(
    `api/cars?${urlParams}`
  );
  return response.data;
};
